import { keysToSnakeCaseDeep } from '@agro1desenvolvimento/utils-js';
import aqilaApi from './aqila-api';

export interface BatchInsumoItem {
  auditoriaIds: number[];
  insumoNew: {
    itemId: number;
    itemTipo: number;
    dose: number;
    unidadeSistema: string;
  };
  insumoOld: {
    itemId: number;
    itemTipo: number;
  };
}

class AuditoriaAplicacoes {
  private readonly endpoint = '/v1/auditoria_aplicacoes';

  async update(id: number, situacao: 'aprovado' | 'rejeitado') {
    await aqilaApi.patch(
      `${this.endpoint}/${id}`,
      keysToSnakeCaseDeep({
        aplicacaoAuditada: {
          situacao,
        },
      }),
    );
  }

  async batchInsumos(propriedadeId: number, batch: BatchInsumoItem[]) {
    await aqilaApi.patch(
      `${this.endpoint}/batch_insumos`,
      keysToSnakeCaseDeep({ batch }),
      {
        params: { propriedade: propriedadeId },
      },
    );
  }
}

export default new AuditoriaAplicacoes();
